import { Button, ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import { RESPONDENT_STATE_IN_LOCAL_STORAGE } from 'client/respondent/core/reducers/context';
import { CurrentUser } from 'client/respondent/hooks';
import { MaterialIcon, MaterialIconName } from 'client/shared/components/base';
import { ClientUrlUtils } from 'client/shared/core/helpers';
import { useLogOut } from 'client/shared/graphql-client/graphql-operations.g';
import { useLocalStorage } from 'client/shared/helpers/hooks';
import { useRedirect } from 'client/shared/hooks';
import React from 'react';

export const LoggedInUser: React.FC<{
  readonly respondent: CurrentUser;
}> = (p) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const redirect = useRedirect();
  const localStorage = useLocalStorage();
  const [logout] = useLogOut();
  return (
    <>
      <Button onClick={(event) => setAnchorEl(event.currentTarget)}>
        {p.respondent.user?.respondent?.firstName}{' '}
        {p.respondent.user?.respondent?.lastName}
        <MaterialIcon icon={MaterialIconName.ARROW_DROP_DOWN} />
      </Button>
      <Menu anchorEl={anchorEl} onClose={() => setAnchorEl(null)} open={!!anchorEl}>
        <MenuItem
          onClick={() =>
            redirect(ClientUrlUtils.respondent.feed.path(), { push: true })
          }
        >
          <ListItemIcon>
            <MaterialIcon
              icon={MaterialIconName.HOME}
              iconType="material-symbols-outlined"
            />
          </ListItemIcon>
          <ListItemText primary="Home" />
        </MenuItem>
        <MenuItem
          onClick={() =>
            redirect(ClientUrlUtils.respondent.account.path(), { push: true })
          }
        >
          <ListItemIcon>
            <MaterialIcon
              icon={MaterialIconName.ACCOUNT_CIRCLE}
              iconType="material-symbols-outlined"
            />
          </ListItemIcon>
          <ListItemText primary="Account" />
        </MenuItem>
        <MenuItem
          onClick={() =>
            redirect(ClientUrlUtils.respondent.subscriptions.path(), { push: true })
          }
        >
          <ListItemIcon>
            <MaterialIcon
              icon={MaterialIconName.ARTICLE_PERSON}
              iconType="material-symbols-outlined"
            />
          </ListItemIcon>
          <ListItemText primary="Following" />
        </MenuItem>
        <MenuItem
          onClick={async () => {
            await logout();
            localStorage?.removeItem(RESPONDENT_STATE_IN_LOCAL_STORAGE);
          }}
        >
          <ListItemIcon>
            <MaterialIcon
              icon={MaterialIconName.EXIT_TO_APP}
              iconType="material-symbols-outlined"
            />
          </ListItemIcon>
          <ListItemText primary="Logout" />
        </MenuItem>
      </Menu>
    </>
  );
};
LoggedInUser.displayName = 'LoggedInUser';
